namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonByItemRow {
        Id?: string;
        DocDate?: string;
        DocNo?: string;
        RefDate?: string;
        RefDoc?: string;
        PluCode?: string;
        ItemDesc?: string;
        Price?: number;
        Qty?: number;
        PosId?: string;
        CashierId?: string;
        AppRefund?: string;
        RefundId?: number;
        RefundReason?: string;
    }

    export namespace ReportRefundReasonByItemRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'RefundReasonReport.ReportRefundReasonByItem';
        export const lookupKey = 'RefundReasonReport.ReportRefundReasonByItem';

        export function getLookup(): Q.Lookup<ReportRefundReasonByItemRow> {
            return Q.getLookup<ReportRefundReasonByItemRow>('RefundReasonReport.ReportRefundReasonByItem');
        }
        export const deletePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายสินค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายสินค้า:View';
        export const readPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายสินค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายสินค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            DocNo = "DocNo",
            RefDate = "RefDate",
            RefDoc = "RefDoc",
            PluCode = "PluCode",
            ItemDesc = "ItemDesc",
            Price = "Price",
            Qty = "Qty",
            PosId = "PosId",
            CashierId = "CashierId",
            AppRefund = "AppRefund",
            RefundId = "RefundId",
            RefundReason = "RefundReason"
        }
    }
}
